import { dbotBlockApi, toConversationRecord } from "dbot/src/business/Functions";
import { MEDIA_URL } from "static-content/RelativeUrlHelperFunctions";
import { fetchBlock, prefetchGifsAndImages } from "./business/DbotHelperFunctions";
import * as R from "ramda";
import { getBlockApiF } from "./app/DbotAppLight";

export const dbotMiddleware = DbotMiddlewarePlugin => ({ getState, dispatch }) => {
  return next => action => {
    if (["DBOT_STORED_POINTER_PUSH", "DBOT_STORED_POINTER_POP"].includes(action.type)) {
      let nextAction = next(action);
      let { savePointers } = DbotMiddlewarePlugin.persistenceFs(getState());
      savePointers(getState().dbotReducer.storedPointers);
      return nextAction;
    } else if (["ADD_AND_INIT_BLOCK", "CLEAR_ADD_AND_INIT_BLOCK"].includes(action.type)) {
      let nextAction = next(action);
      if (isEndOfConversation(action.payload.records, [], action.payload.blockApi))
        dispatch({ type: "DBOT_END_OF_CONVERSATION" });
      return nextAction;
    }
    if (action.type !== "DBOT_CLICK") return next(action);
    let { saveRecords } = DbotMiddlewarePlugin.persistenceFs(getState());
    if (clickToBeIgnored(action.payload, DbotMiddlewarePlugin.TAGS_TO_IGNORE)) return next(action);
    let result = processCurrentButton(action, getState().dbotReducer, dispatch);
    saveRecords(result.records);
    let nextAction = next({ ...action, payload: { ...action.payload, records: result.records } });
    if (result.isEnd) dispatch({ type: "DBOT_END_OF_CONVERSATION" });
    if (hasNotification(action)) {
      dispatch({ type: "DBOT_NOTIFICATION", payload: getNotification(action) });
    }
    DbotMiddlewarePlugin.evaluateSpecialBehavior(action.payload, dispatch, getState());
    return nextAction;
  };
};

const hasNotification = action => action.payload && action.payload.button && action.payload.button.notification;

const getNotification = action => {
  const id = `${action.payload.button.blockName}_${action.payload.button.id}`;
  return { ...action.payload.button.notification, id: id };
};

const getNextNodes = (button, dispatch, blockApis) => {
  if (button.metaPointer && !!button.metaPointer.block && Number.isInteger(button.metaPointer.id)) {
    let api = dbotBlockApi(fetchBlock(button.metaPointer.block));
    if (api === null) return processCurrentButtonPointer(button, blockApis);
    prefetchGifsAndImages(api, MEDIA_URL);
    if (button.pointer != null) {
      dispatch({ type: "DBOT_STORED_POINTER_PUSH", payload: { block: button.blockName, id: button.pointer}});
    }
    dispatch({ type: "DBOT_SET_CURRENT_API", payload: api});
    return api.processNode(button.metaPointer.id);
  }
  return processCurrentButtonPointer(button, blockApis);
};

const processCurrentButtonPointer = (button, blockApis) =>
  Number.isInteger(button.pointer) ?  getBlockApiF(blockApis)(button.blockName).processNode(button.pointer) : [];

const isEndOfConversation = (nextNodes, storedPointers, blockApi) => {
  return (
    storedPointers.length === 0 &&
    !nextNodes.some(n => {
      let node = blockApi.getNode(n.id);
      return node && ["button", "button-box"].includes(node.type);
    })
  );
};

const processCurrentButton = (action, dbotReducer, dispatch) => {
  let storedPointers = dbotReducer.storedPointers;
  let { button } = action.payload;
  let nextNodes = getNextNodes(button, dispatch, dbotReducer.apis);
  let storedPointerNodes = getStoredPointerNodes(nextNodes, storedPointers, dispatch);
  return {
    records: [toConversationRecord(button.blockName, button, new Date(), button.textInput), ...nextNodes, ...storedPointerNodes],
    isEnd: isEndOfConversation(nextNodes, storedPointers, dbotReducer.blockApi)
  };
};

let getStoredPointerNodes = (nextNodes, storedPointers, dispatch) => {
  if (storedPointers.length === 0 || (nextNodes.length > 0 && R.last(nextNodes).type === "button")) return [];
  let storedPointer = storedPointers[0];
  dispatch({ type: "DBOT_STORED_POINTER_POP" });
  let api = dbotBlockApi(fetchBlock(storedPointer.block));
  prefetchGifsAndImages(api, MEDIA_URL);
  return api.processNode(storedPointer.id);
};

const clickToBeIgnored = (payload, tagsToBeIgnored) => {
  let { button } = payload;
  return !button || (button.tag && tagsToBeIgnored.includes(button.tag.code));
};


